import { FormInput } from '@zola/zola-ui/src/components/Form/InputFieldV2';

import { MONEY, GREATER_THAN_ZERO } from '~/components/common/form/commonValidations';
import { FormCheckbox } from '~/components/common/form/FinalForm/Inputs';
import { LESS_THAN_ONE_MILLION } from '~/components/common/form/FinalForm/utils/formUtils';

import styles from './questions.module.less';

export const GeneralQuestions = (): JSX.Element => (
  <div className={styles.general}>
    <FormInput
      name="serviceEndPriceCents"
      label="Budget"
      addOn="cash"
      validate={[MONEY, GREATER_THAN_ZERO, LESS_THAN_ONE_MILLION]}
      allowChangeToEmpty
    />
    <FormCheckbox name="flexibleOnPrice" label="This is flexible" className={styles.flexible} />
  </div>
);
